import { FormattedMessage } from 'react-intl'

import { type TTypographyProps, Typography } from '@/src/elements/text/Typography'
import type { TMessageKey } from '@/src/lang/useTranslate'

type TSettingsCardSettingsContentProps = {
  title: TMessageKey
  description: TMessageKey
} & Pick<TTypographyProps, 'colors'>

export const SettingsCardSettingsContent = ({ colors, description, title }: TSettingsCardSettingsContentProps) => (
  <>
    <Typography bold colors={colors}>
      <FormattedMessage id={title} />
    </Typography>
    <Typography size="sm" colors={colors}>
      <FormattedMessage id={description} />
    </Typography>
  </>
)
